import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export default function ListFilterEmptyState() {
  const { t } = useTranslation();

  return (
    <Box sx={{ textAlign: 'center', py: 5 }}>
      <Typography color="text.secondary">{t('system.listFilters.noResults')}</Typography>
    </Box>
  );
}
